export default class ForbiddenError extends Error {
}
